module.exports = __webpack_public_path__ + "static/classroom2@large-a6e7602144247e8a866bd18709d81022.jpg";